import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/diario.scss'
import moment from 'moment';

const Projeto = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>{props.projeto.patrocinador} para {props.projeto.beneficiario}</h5></Card.Header>
                    <Card.Body>
                        <p>Data de Captação: {moment(props.projeto.dataCap).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</p>
                        <p>Situação: {props.projeto.andamento}</p>
                        <p>Prazo: {props.projeto.prazo}</p>
                        <p>Valor Captado: {props.projeto.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Projeto;